export default __webpack_public_path__ + "static/video-dbff40b31bd94416ec7b435ea8e9306f.jpg";